var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "97c100e8e50a2fc4d01ba9a73359796284dd5dd8"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ecommerce-rms-rodi-es@rodi"] = {
  id: "97c100e8e50a2fc4d01ba9a73359796284dd5dd8"
};